
// Diese Werte werden in die e5-Tracking-Datenbank fürs Dashboard geschrieben.
export const STATE_DISPLAY_NAMES = {
    'zipCodeQuestion': 'Frage: PLZ-Eingabe',
    'zipCodeNotAvailable': 'Abbruch: PLZ nicht verfügbar',
    'buildingTypeQuestion': 'Frage: Gebäudetyp',
    'buildingTypeNotAvailable': 'Abbruch: Gebäudetyp nicht verfügbar',
    'ownerQuestion': 'Frage: Eigentümer',
    'ownerNotAvailable': 'Abbruch: Eigentümer nicht verfügbar',
    'alreadyBuiltQuestion': 'Frage: Haus fertig',
    'buildingYearNotAvailable': 'Abbruch: Baujahr nicht verfügbar',
    'powerConsumersQuestion': 'Frage: Verbraucher',
    'powerStorageQuestion': 'Frage: Speicher',
    'wallboxQuestion': 'Frage: Wallbox',
    'heatPumpgQuestion': 'Frage: Wärmepumlte',
    'plannedReplacementQuestion': 'Frage: Geplanter Austausch',
    'appointmentTypeQuestion': 'Frage: Vor-Ort-Termin',
    'contactInformationQuestion': 'Frage: Kontaktinformationen',
};

// Für diese States soll keine Fortschrittsanzeige erscheinen.
export const statesWithoutHeadline = [
    'zipCodeNotAvailable',
    'buildingTypeNotAvailable',
    'ownerNotAvailable',
    'buildingYearNotAvailable',
    'monumentNotAvailable',
    'renovationNotAvailable',
    'heatingLocationNotAvailable',
];

// Das ist die Reihenfolge der Qualifizierungsfragen. Sie wird für die Fortschrittsanzeige verwendet.
export const QUESTION_STEPS_ORDER = [
    'buildingTypeQuestion',
    'ownerQuestion',
    'alreadyBuiltQuestion',
    'zipCodeQuestion',
    'powerConsumersQuestion',
    'wishPowerStorageQuestion',
    'wishWallboxQuestion',
    'wishHeatpumpQuestion',
    'plannedReplacementQuestion',
    'appointmentTypeQuestion',
    'contactInformationQuestion',
];

// Für die PostMessages ergibt sich die ScreenNumber aus der Reihenfolge der Qualifizierungsfragen
// Außerdem brauchen wir die ScreenNumber des Kontaktformulars und der Bestätigungsseite
export const QUESTION_STEPS_ORDER_FOR_MESSAGE_STATES = [
    ...QUESTION_STEPS_ORDER,
    'submissionSuccess'
];

// Die Struktur der Message für die PostMessages
const BASE_POST_MESSAGE_STATES = {
    buildingTypeQuestion: {
        screen_name: 'gebaeudeart',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    buildingTypeNotAvailable: {
        screen_name: 'absage gebaeudeart',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    zipCodeQuestion: {
        screen_name: 'plz-abfrage',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    zipCodeNotAvailable: {
        screen_name: 'absage plz-abfrage',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    ownerQuestion: {
        screen_name: 'eigentumsverhaeltnis',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    ownerNotAvailable: {
        screen_name: 'absage eigentumsverhaeltnis',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    alreadyBuiltQuestion: {
        screen_name: 'bauzustand',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    buildingYearNotAvailable: {
        screen_name: 'absage bauzustand',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    powerConsumersQuestion: {
        screen_name: 'verbraucher',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    wishPowerStorageQuestion: {
        screen_name: 'wunsch speicher',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    wishWallboxQuestion: {
        screen_name: 'wunsch wallbox',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    wishHeatpumpQuestion: {
        screen_name: 'wunsch waermepumpe',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    plannedReplacementQuestion: {
        screen_name: 'zeitpunkt',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    appointmentTypeQuestion: {
        screen_name: 'wunsch vor-ort-termin',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    contactInformationQuestion: {
        screen_name: 'kontaktformular',
        conversion: false,
        action: 'view_screen',
        route_name: 'solar',
    },
    submissionSuccess: {
        screen_name: 'bestaetigung',
        conversion: true,
        action: 'view_screen',
        route_name: 'solar',
    },
};

// POST_MESSAGE_STATES Objekt mit dynamischen screen_numbern generieren
export const POST_MESSAGE_STATES = Object.keys(BASE_POST_MESSAGE_STATES).reduce((acc, stateKey) => {
    let screenNumber = 99; // Standardwert

    // Prüfen, ob der Schlüssel in QUESTION_STEPS_ORDER_FOR_MESSAGE_STATES vorkommt
    const questionIndex = QUESTION_STEPS_ORDER_FOR_MESSAGE_STATES.indexOf(stateKey);
    if (questionIndex !== -1) {
        screenNumber = questionIndex + 1;
    }

    acc[stateKey] = {
        ...BASE_POST_MESSAGE_STATES[stateKey],
        screen_number: screenNumber,
    };
    return acc;
}, {});

